import { atom } from "@reatom/core";


export const scoreTableVisibleAtom = atom(false)

export const streamVisibleAtom = atom(false)
// export const scoreTableVisibleAtom = atom(true)